import { MapSaveConflictError } from './map-save-request.js';

export type MapSaveResult = 'saved' | 'canceled' | 'dialog_error' | 'failed';

// Existing save callers already handle a stopped conflict as an expected outcome.
export class MapSaveCanceledError extends MapSaveConflictError {
  constructor() {
    super();
    this.name = 'MapSaveCanceledError';
    this.message = 'Saving was canceled';
  }
}

export class MapSaveDialogError extends Error {
  constructor(cause?: unknown) {
    super('The save dialog could not open', { cause });
    this.name = 'MapSaveDialogError';
  }
}
